import React from 'react';

import {Box, Button as MuiButton} from '@mui/material';
import {Grid} from '@mui/material';


import {styled} from '@mui/system';

import {Styles} from '../Styles/Styles.js';
import PropTypes from 'prop-types';


const ToolbarBox = ({children}) => {
  ToolbarBox.propTypes = {
    children: PropTypes.node.isRequired
  };
  const cols = 12;
  const showChildren = () => {
    if (!children) {
      return children;
    } else if (React.Children.count(children) == 1) {
      return <Grid container alignItems="center" column={cols}>
        <Grid item xs={0} md={10}>
        </Grid>
        <Grid item xs={1} md={2}>
          {children}
        </Grid>
      </Grid>;
    } else if ((React.Children.count(children) * 2) < cols) {
      return <Grid container alignItems="center">
        <Grid item xs={0} md={cols - 2 * React.Children.count(children)}>
        </Grid>
        {
          React.Children.map(children, (aChild) => {
            return <Grid item xs={2} md={2}>
              {aChild}
            </Grid>;
          })
        }
      </Grid>;
    } else {
      return children;
    }
  };

  return <Box sx={{
    // fontSize: "1",
    paddingTop: '2.5em'
  }}>{showChildren()}</Box>;
};

const Toolbar = styled(ToolbarBox)(({theme}) => ({

}));


const Button = styled(MuiButton)(({theme}) => ({
  ...Styles.toolbarButton,
  ...{backgroundColor: theme.palette.primary}
}));


export default Toolbar;
export {Button};
